'use strict';

angular.module('app.front')
    .config(['$stateProvider', 'RouteProvider', function($stateProvider, RouteProvider) {
        $stateProvider.state(RouteProvider.create('front', {
            url: '/',
            secure: false,
            redirectIf: {
                logged: 'studies',
                notLogged: 'login',
            },
        }));
    }]);
